import React from 'react';
import { Pie } from '@ant-design/plots';

export interface Props {
  data: Data[];
  total: number;
}

export type Data = {
  type: string;
  value: number;
};

const DemoPie: React.FC<Props> = ({ data, total }) => {
  const [dados, setDados] = React.useState<Data[]>([]);

  React.useEffect(() => {
    setDados(data);
  }, [data]);

  const content = `
  <div style="display:block; background:transparent;" class="themeDashboard">
    <div>${total ?? 0}%</div>
  </div>`;

  const config = {
    appendPadding: 10,
    data: dados,
    angleField: 'value',
    colorField: `${'type'}`,

    color: ['#3c6ab4', '#f63b3b'],

    radius: 1,
    innerRadius: 0.6,

    label: {
      type: 'inner',
      offset: '-50%',
      content: '{value}',

      autoRotate: false,
      style: {
        textAlign: 'center',
        fontSize: 14,
      },
    },

    legend: {
      maxItemWidth: 130,
    },

    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],

    statistic: {
      title: undefined,
      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        content: content,
      },
    },
  };
  return <Pie {...config} />;
};

export default DemoPie;
